<template>
    <div>
        <v-card class="mb-2">
            <v-tabs
                fixed-tabs
                class="ipaymu-bg-color"
            >
                <v-tab @click="changeTab()">All</v-tab>
                <v-tab @click="changeTab('payment_channel')">Payment Channel</v-tab>
                <v-tab @click="changeTab('ecosystem')">Ecosystem</v-tab>
            </v-tabs>
        </v-card>
        <v-card
            outlined
        >
            <v-card-title>
                <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                @change="getHealthCheck"
            ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="healthchecks"
                :search="search"
                :options.sync="pagination"
                :server-items-length="total"
                :footer-props="{'items-per-page-options': [30, 50, 100]}"
                :items-per-page="30"
                :loading="loading"
                :loading-text="loadingtext"
            >
                <template v-slot:item="props">
                    <tr>
                        <td class="text-xs-center" align="center">{{ props.item.Type }}</td>
                        <td class="text-xs-center" align="center">{{ props.item.Name }}</td>
                        <td class="text-xs-center" align="center">
                            <b-badge pill :variant="props.item.StatusColorBs">{{ props.item.StatusText }}</b-badge>
                            
                        </td>
                        <td class="text-xs-center" align="center">{{ props.item.UpdatedAt }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
    import HealthCheckService from "../../services/HealthCheckService";
    export default {
        data () {
            return {
                title: 'iPaymu Status',
                search: '',
                type: '',

                pagination: {},
                form: {},
                loading: false,
                loadingtext: '',
    
                headers: [
                    { text: 'Type', align: 'center', value: 'Type', sortable: false },
                    { text: 'Service Name', align: 'center', value: 'Name', sortable: false },
                    { text: 'Status', align: 'center', value: 'StatusText', sortable: false },
                    { text: 'Last Updated', align: 'center', value: 'UpdatedAt', sortable: false },
                ],
                total: 0,

                healthchecks: [],
            }
        },
        created() {
            // this.getHealthCheck();
            this.timer = setInterval(this.getHealthCheck, 60000);
        },
   
        watch: {
            pagination() {
               this.getHealthCheck()
            },
        },
        methods:{
           
            getHealthCheck() {
                this.loading = true
                this.loadingtext = 'Loading... Please wait'

                this.form.type = this.type
                this.form.search = this.search
                this.form.page = this.pagination.page
                this.form.perpage = this.pagination.itemsPerPage
                this.form.sortBy = this.pagination.sortBy
                this.form.direction = this.pagination.sortDesc
                
                console.log(this.form)
               
                HealthCheckService.fetch(this.form).then(response => {
                    // const { healtchecks, totalItems } = response.data.Data.HealthCheck;
                    // this.healtchecks = healtchecks;
                    // this.count = totalItems;
                    console.log(response.data);
                    this.healthchecks = response.data.Data.HealthCheck
                    this.total = response.data.Data.Pagination.total
                    // this.loaxding = false
                    // this.healtchecks = response.data.Data.HealthCheck
                }).catch(error => {
                    console.log(error.response)
                    // this.loading = false
                })
                .finally(() => {
                    this.loading = false
                    this.loadingtext = ''
                    // this.panel = null
                });
            },

            changeTab(val) {
                this.type = val
                this.getHealthCheck()
            }
               
        }
    }
</script>